import { useEffect, useRef } from 'react';
import { getKrpanoMockData } from '../../utils';

function KrpanoView() {
  const panoDom = useRef<HTMLDivElement>(null);

  useEffect(() => {
    initPano();
  }, []);

  const initPano = async () => {
    const dom = panoDom.current;
    if (!dom) {
      return;
    }
    while (dom.hasChildNodes()) {
      dom.removeChild(dom.firstChild as ChildNode);
    }

    // 开发环境可以使用mock中的配置路径加载krpano
    const mockData = getKrpanoMockData();
    // 生产环境由krpano-core负责配置加载，只需使用env=0指定为生产环境即可
    const loadParams = {
      env: 0,
      ...mockData,
    };
    await window.pageInit(loadParams);
  };

  return <div id='pano' className='krpano-view' ref={panoDom} />;
}

export default KrpanoView;
